import '../ChangeRequestComment/comments.scss';

import React from 'react';
import {
  Card,
  CardBody,
  CardText,
  CardTitle,
  Label,
  UncontrolledCollapse,
} from 'reactstrap';

import { lineLanguages } from '../../campaign-editor/constants';
import { campaignLineShape } from '../../prop-types';

function NewDraftCampaignLineTextCopy({ line }) {
  const languages = lineLanguages(line);
  const { product } = line;

  return languages.map((languageCode, index) => {
    const collapseId = `langLineToggle-${line.id}-${languageCode}`;
    return (
      <Card color="light" key={languageCode}>
        <CardTitle
          className="px-2 c-comment__campaignline_language_header "
          id={collapseId}
        >
          <Label className="c-comment__field-label dropdown-toggle mr-2">
            {languageCode}
          </Label>
        </CardTitle>
        <UncontrolledCollapse toggler={collapseId}>
          <CardBody className="p-2">
            {product.hasSubTitle && (
              <CardText className="mb-1">
                <Label className="c-comment__field-label d-block mb-0">
                  Headline
                </Label>
                {line[`subTitle${index + 1}`]}
              </CardText>
            )}

            {product.hasTitle && (
              <CardText className="mb-1">
                <Label className="c-comment__field-label d-block mb-0">
                  Subline
                </Label>
                {line[`title${index + 1}`]}
              </CardText>
            )}

            {product.hasText && (
              <CardText className="mb-1">
                <Label className="c-comment__field-label d-block mb-0">
                  Description
                </Label>
                {line[`desc${index + 1}`]}
              </CardText>
            )}

            {product.hasCta && (
              <CardText className="mb-1">
                <Label className="c-comment__field-label d-block mb-0">
                  CTA
                </Label>
                {line[`cta${index + 1}`]}
              </CardText>
            )}

            {product.hasLp && (
              <CardText className="mb-1">
                <Label className="c-comment__field-label d-block mb-0">
                  Landing page
                </Label>
                <a
                  href={line[`landingPage${index + 1}`]}
                  className="c-comment__campaignline_details"
                >
                  {line[`landingPage${index + 1}`]}
                </a>
              </CardText>
            )}
          </CardBody>
        </UncontrolledCollapse>
      </Card>
    );
  });
}

NewDraftCampaignLineTextCopy.propTypes = {
  line: campaignLineShape.isRequired,
};

export default NewDraftCampaignLineTextCopy;
